import { render } from "./measureForm.vue?vue&type=template&id=20b830fd&scoped=true"
import script from "./measureForm.vue?vue&type=script&lang=js"
export * from "./measureForm.vue?vue&type=script&lang=js"

import "./measureForm.vue?vue&type=style&index=0&id=20b830fd&scoped=true&lang=css"

import exportComponent from "A:\\Practice_Websites\\paint-amount\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20b830fd"]])

export default __exports__